<template>
  <div>
    页面不存在或没有权限，请联系管理员<el-button v-on:click="logout" type="text"
      >退出登录</el-button
    >
  </div>
</template>

<script>
export default {
  name: "notFound",
  methods: {
    logout() {
      this.$store.dispatch("logOut").then(() => {
        location.reload();
      });
    },
  },
};
</script>

<style scoped></style>
